import type { MisconceptionDefinition } from '../types';
export const inhoudMisconceptions: MisconceptionDefinition[] = [{
  id: 'met.inhoud-trede-aantal-fout',
  label: 'Verkeerd aantal treden gebruikt',
  module: 'Metriek',
  description: 'Leerling gebruikt het verkeerde aantal treden op de metrieke trap (bijv. 2 i.p.v. 3 treden tussen liter en milliliter).',
  typicalFamilies: ['MET-INH-LITER', 'MET-INH-CITER', 'MET-INH-OMREKEN']
}, {
  id: 'met.inhoud-eenheid-verward',
  label: 'Inhoudseenheid verward',
  module: 'Metriek',
  description: 'Leerling verwart twee inhoudseenheden (bijv. ml en dl als gelijk gezien, of liter ≈ deciliter).',
  typicalFamilies: ['MET-INH-LITER', 'MET-INH-CITER', 'MET-INH-OMREKEN']
}, {
  id: 'met.inhoud-cm3-direct-als-liter',
  label: 'cm³ direct als liter genomen',
  module: 'Metriek',
  description: 'Leerling beschouwt het aantal cm³ direct als aantal liters (vergeet ÷1.000) bij omrekening van blokinhoud naar liter.',
  typicalFamilies: ['MET-INH-LITER', 'MET-INH-BLOK', 'MET-INH-OMREKEN']
}, {
  id: 'met.kubiek-x10-ipv-x1000',
  label: 'Kubieke trap met ×10 i.p.v. ×1000',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt of deelt met factor 10 per trede bij kubieke maten (m³ → dm³) in plaats van factor 1.000.',
  typicalFamilies: ['MET-INH-OMREKEN-KUBIEK', 'MET-INH-OMREKEN']
}, {
  id: 'met.kubiek-x100-ipv-x1000',
  label: 'Kubieke trap met ×100 i.p.v. ×1000',
  module: 'Metriek',
  description: 'Leerling gebruikt factor 100 per trede bij kubieke maten (verwart met oppervlakte) in plaats van 1.000.',
  typicalFamilies: ['MET-INH-OMREKEN-KUBIEK', 'MET-INH-OMREKEN']
}, {
  id: 'met.kubiek-delen-ipv-vermenigvuldigen',
  label: 'Delen i.p.v. vermenigvuldigen bij kubiek',
  module: 'Metriek',
  description: 'Leerling deelt bij omrekening naar een kleinere kubieke eenheid in plaats van te vermenigvuldigen (richting omgedraaid).',
  typicalFamilies: ['MET-INH-OMREKEN-KUBIEK', 'MET-INH-OMREKEN']
}, {
  id: 'met.kubiek-x10000-ipv-x1000',
  label: '×10.000 i.p.v. ×1.000 bij kubieke omrekening',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt een keer te veel bij kubieke omrekening (×10.000 i.p.v. ×1.000), bijv. door oppervlakte-regel met inhoud-regel te combineren.',
  typicalFamilies: ['MET-INH-OMREKEN-KUBIEK']
}, {
  id: 'met.inhoud-trap-1-trede-l-cl',
  label: 'l→cl als 1 trede (×10)',
  module: 'Metriek',
  description: 'Leerling denkt dat van liter naar centiliter slechts 1 trede is (×10) i.p.v. 2 treden (×100).',
  typicalFamilies: ['MET-INH-CITER', 'MET-INH-LITER']
}, {
  id: 'met.inhoud-trap-3-treden-l-cl',
  label: 'l→cl als 3 treden (×1000)',
  module: 'Metriek',
  description: 'Leerling denkt dat van liter naar centiliter 3 treden is (×1000) i.p.v. 2 treden (×100) — verwart cl met ml.',
  typicalFamilies: ['MET-INH-CITER', 'MET-INH-LITER']
}, {
  id: 'met.inhoud-trap-richting-fout-l-cl',
  label: 'l→cl richting omgekeerd',
  module: 'Metriek',
  description: 'Leerling deelt waar vermenigvuldigd moet worden bij groot→klein (l→cl) — richting op de metrieke trap omgedraaid.',
  typicalFamilies: ['MET-INH-CITER', 'MET-INH-LITER']
}, {
  id: 'met.inhoud-trap-1-trede-cl-l',
  label: 'cl→l als 1 trede (÷10)',
  module: 'Metriek',
  description: 'Leerling denkt dat van centiliter naar liter slechts 1 trede is (÷10) i.p.v. 2 treden (÷100).',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-trap-3-treden-cl-l',
  label: 'cl→l als 3 treden (÷1000)',
  module: 'Metriek',
  description: 'Leerling denkt dat van centiliter naar liter 3 treden is (÷1000) i.p.v. 2 treden (÷100).',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-trap-richting-fout-cl-l',
  label: 'cl→l richting omgekeerd',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt waar gedeeld moet worden bij klein→groot (cl→l) — richting op de metrieke trap omgedraaid.',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-trap-2-treden-dl-cl',
  label: 'dl→cl als 2 treden (×100)',
  module: 'Metriek',
  description: 'Leerling denkt dat van deciliter naar centiliter 2 treden is (×100) i.p.v. 1 trede (×10).',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-dl-cl-gelijk',
  label: 'Deciliter en centiliter als gelijk',
  module: 'Metriek',
  description: 'Leerling behandelt deciliter en centiliter alsof het dezelfde eenheid is, zonder factor 10 om te rekenen.',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-trap-richting-fout-dl-cl',
  label: 'dl→cl richting omgekeerd',
  module: 'Metriek',
  description: 'Leerling deelt waar vermenigvuldigd moet worden bij groot→klein (dl→cl) — richting op de metrieke trap omgedraaid.',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-trede-te-weinig',
  label: 'Te weinig stappen op het metrieke trapje (inhoud)',
  module: 'Metriek',
  description: 'Leerling rekent met te weinig stappen bij inhoudomrekening (bijv. ×10 of ×100 i.p.v. ×1000 van l naar ml).',
  typicalFamilies: ['MET-INH-OMREKEN', 'MET-INH-OMREKEN-KUBIEK', 'MET-INH-LITER', 'MET-INH-CITER']
}, {
  id: 'met.inhoud-trede-te-veel',
  label: 'Te veel stappen op het metrieke trapje (inhoud)',
  module: 'Metriek',
  description: 'Leerling rekent met een stap te veel bij inhoudomrekening (bijv. ×10.000 i.p.v. ×1000).',
  typicalFamilies: ['MET-INH-OMREKEN', 'MET-INH-OMREKEN-KUBIEK', 'MET-INH-LITER']
}, {
  id: 'met.inhoud-richting-omgedraaid',
  label: 'Richting omgedraaid bij inhoud (× i.p.v. ÷)',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt waar gedeeld moet worden (of omgekeerd) bij inhoudomrekening (klein → groot = ÷, groot → klein = ×).',
  typicalFamilies: ['MET-INH-OMREKEN', 'MET-INH-LITER', 'MET-INH-CITER']
}, {
  id: 'met.inhoud-extra-factor',
  label: 'Inhoud met extra factor vermenigvuldigd',
  module: 'Metriek',
  description: 'Leerling vermenigvuldigt het volume-resultaat met een extra dimensie (bijv. (l×b×h)×l) bij blok-inhoud.',
  typicalFamilies: ['MET-INH-BLOK', 'MET-INH-OMREKEN-KUBIEK']
}, {
  id: 'met.inhoud-oppervlakte-ipv-inhoud',
  label: 'Oppervlakte berekend in plaats van inhoud',
  module: 'Metriek',
  description: 'Leerling berekent l×b (oppervlakte van een vlak) in plaats van l×b×h (inhoud van het blok).',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-dimensie-vergeten',
  label: 'Dimensie vergeten bij inhoud',
  module: 'Metriek',
  description: 'Leerling vergeet één van de drie afmetingen mee te nemen in de inhoudsberekening van een blok.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-door-inhoud-gedeeld',
  label: 'Door de inhoud zelf gedeeld',
  module: 'Metriek',
  description: 'Leerling deelt door de totale inhoud i.p.v. door een specifieke afmeting bij het vinden van een onbekende lengte.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-door-een-dim-gedeeld',
  label: 'Slechts door één afmeting gedeeld',
  module: 'Metriek',
  description: 'Leerling deelt door één afmeting i.p.v. door het product van twee bekende afmetingen.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-aftrekken-ipv-delen',
  label: 'Aftrekken i.p.v. delen bij onbekende dimensie',
  module: 'Metriek',
  description: 'Leerling trekt afmetingen af i.p.v. de inhoud te delen om een onbekende dimensie te vinden.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-getal-verkeerd-gelezen',
  label: 'Getal verkeerd gelezen bij inhoud',
  module: 'Metriek',
  description: 'Leerling leest een afmeting verkeerd af uit de opgave en gebruikt dat getal in de inhoudsberekening.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-vlakken-als-afmeting',
  label: 'Aantal vlakken als afmeting gebruikt',
  module: 'Metriek',
  description: 'Leerling gebruikt het aantal vlakken van een kubus (6) als afmeting in de inhoudsberekening.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-optellen-ipv-vermenigvuldigen',
  label: 'Optellen i.p.v. vermenigvuldigen bij inhoud',
  module: 'Metriek',
  description: 'Leerling telt de afmetingen op (l + b + h) i.p.v. ze te vermenigvuldigen voor de inhoud.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-grootste-afmeting-drogreden',
  label: 'Op grootste afmeting alleen vergeleken',
  module: 'Metriek',
  description: 'Leerling kiest welk blok meer inhoud heeft op basis van één grootste afmeting i.p.v. de inhouden te vergelijken.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-rekenfout',
  label: 'Rekenfout bij vergelijken van inhouden',
  module: 'Metriek',
  description: 'Leerling maakt een rekenfout bij het berekenen van inhouden om te vergelijken.',
  typicalFamilies: ['MET-INH-BLOK']
}, {
  id: 'met.inhoud-vergelijken-zonder-omrekening',
  label: 'Inhouden vergeleken zonder omrekenen',
  module: 'Metriek',
  description: 'Leerling vergelijkt inhouden in verschillende eenheden zonder eerst om te rekenen (kiest het hoogste getal).',
  typicalFamilies: ['MET-INH-OMREKEN']
}, {
  id: 'met.inhoud-grootste-eenheid-gekozen',
  label: 'Grootste eenheid gekozen als "meest"',
  module: 'Metriek',
  description: 'Leerling kiest de optie met de grootste eenheid (bijv. liter) als "het meest", ongeacht het getal.',
  typicalFamilies: ['MET-INH-OMREKEN']
}, {
  id: 'met.inhoud-ml-cl-conversie-fout',
  label: 'Fout bij ml→cl conversie',
  module: 'Metriek',
  description: 'Leerling maakt een fout bij het omrekenen van milliliter naar centiliter (÷10).',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.inhoud-dl-cl-conversie-fout',
  label: 'Fout bij dl→cl conversie',
  module: 'Metriek',
  description: 'Leerling maakt een fout bij het omrekenen van deciliter naar centiliter (×10).',
  typicalFamilies: ['MET-INH-CITER']
}, {
  id: 'met.eenheden-niet-gelijktrekken',
  label: 'Eenheden niet gelijkgetrokken vóór bewerking',
  module: 'Metriek',
  description: 'Leerling deelt of vergelijkt twee inhouden zonder eerst de eenheden gelijk te trekken.',
  typicalFamilies: ['MET-INH-CITER', 'MET-INH-OMREKEN']
}, {
  id: 'met.kubiek-dm3-liter-misverstand',
  label: 'm³ → liter conversie fout',
  module: 'Metriek',
  description: 'Leerling maakt een fout bij het omrekenen van m³ naar liter (1 m³ = 1.000 l).',
  typicalFamilies: ['MET-INH-OMREKEN-KUBIEK']
}, {
  id: 'met.inhoud-referentie-badkuip-fout',
  label: 'Badkuip-inhoud verkeerd geschat',
  module: 'Metriek',
  description: 'Leerling schat de inhoud van een badkuip buiten de realistische range (~150 l).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-referentie-drinkpak-fout',
  label: 'Drinkpak-inhoud verkeerd geschat',
  module: 'Metriek',
  description: 'Leerling schat de inhoud van een drinkpak buiten de realistische range (~200 ml).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-eenheid-te-groot',
  label: 'Te grote inhoudseenheid gekozen',
  module: 'Metriek',
  description: 'Leerling kiest een te grote eenheid (bijv. liter) voor een kleine hoeveelheid.',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-eenheid-deciliter-default',
  label: 'Deciliter als default eenheid',
  module: 'Metriek',
  description: 'Leerling kiest deciliter terwijl milliliter de gebruikelijke eenheid zou zijn.',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-eenheid-veel-te-groot',
  label: 'Eenheid orde van grootte te groot',
  module: 'Metriek',
  description: 'Leerling kiest een veel te grote eenheid (bijv. m³ voor een kopje).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-glasinhoud-verkeerd',
  label: 'Glasinhoud verkeerd afgelezen',
  module: 'Metriek',
  description: 'Leerling leest de inhoud van een glas verkeerd af op een referentiebeeld.',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-glasinhoud-overschat',
  label: 'Glasinhoud overschat',
  module: 'Metriek',
  description: 'Leerling schat een glas op een te grote inhoud (bijv. 500 ml i.p.v. ~200 ml).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-glasinhoud-onderschat',
  label: 'Glasinhoud onderschat',
  module: 'Metriek',
  description: 'Leerling schat een glas op een te kleine inhoud (bijv. 50 ml — shotglas).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-glas-overschat',
  label: 'Glas op 10 liter geschat',
  module: 'Metriek',
  description: 'Leerling schat de inhoud van een glas op een absurde grote waarde (10 l).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-theelepel-overschat',
  label: 'Theelepel op 10 liter geschat',
  module: 'Metriek',
  description: 'Leerling schat de inhoud van een theelepel op een absurde grote waarde (10 l).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-zwembad-onderschat',
  label: 'Zwembad op 10 liter geschat',
  module: 'Metriek',
  description: 'Leerling schat de inhoud van een zwembad op een absurd kleine waarde (10 l).',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-volgorde-eenheden-fout',
  label: 'Inhouden vergeleken zonder eenheden gelijk te trekken',
  module: 'Metriek',
  description: 'Leerling rangschikt inhouden zonder eerst om te rekenen naar dezelfde eenheid.',
  typicalFamilies: ['MET-INH-SCHATTEN']
}, {
  id: 'met.inhoud-kleinste-eenheid-onderschat',
  label: 'Onderschat ml als kleine eenheid',
  module: 'Metriek',
  description: 'Leerling heeft geen gevoel voor de grootte van een milliliter en kiest daardoor een eenheid die orden van grootte afwijkt.',
  typicalFamilies: ['MET-INH-OMREKEN']
}];